<template>
    <div class="border-b border-[#eeeff2] mb-1.5 py-3">
        <span class="block text-[20px] font-[CircularBook] text-center">What is {{currency.name}}?</span>
    </div>
    <div class="px-5 py-3.5 text-[14px] font-[CircularBook]">
        <span class="block" v-html="descriptionArray[0]"></span>
        <span class="block" v-if="descriptionArray[1]">
            <span class="text-[#366ff2]">Definition:</span>
            {{descriptionArray[1]}}
        </span>
    </div>
</template>

<script setup>
const currency = pageData.market.from_cgw_currency;
const info = currency.currency_info;
const descriptionArray = info.description.split('<br><br> Definition:');
</script>
